import { Checkbox, TableCell, TableRow } from '@mui/material';
import { AdviseSupplierLineItem } from '../../../../types/advise';
import { LineCategory } from './LineCategory';
import { OutOfScopeTag } from './OutOfScopeTag';
import { dollars } from './currentSupplierSpend';

export interface InvoiceLineRowProps {
  line: AdviseSupplierLineItem;
  categories: string[];
  canEdit: boolean;
  onScopeChange: (inScope: boolean) => void;
  onCategoryChange: (category: string) => void;
}

/** One invoice line: its IN SCOPE checkbox, its category, and an out-of-scope line greyed and tagged. */
export const InvoiceLineRow = ({ line, categories, canEdit, onScopeChange, onCategoryChange }: InvoiceLineRowProps) => {
  const label = line.description || line.category;
  // MUI's own cell colour is injected after Tailwind's, so only an important class wins over it.
  const muted = line.in_scope ? '' : '!text-grey-4';
  return (
    <TableRow className={line.in_scope ? '' : 'bg-grey-1'}>
      <TableCell padding="checkbox">
        <Checkbox
          size="small"
          checked={line.in_scope}
          disabled={!canEdit}
          inputProps={{ 'aria-label': `In scope: ${label}` }}
          onChange={(event) => onScopeChange(event.target.checked)}
        />
      </TableCell>
      <TableCell className={muted || '!text-grey-6'}>
        <LineCategory
          line={line}
          label={label}
          categories={categories}
          canEdit={canEdit}
          onCategoryChange={onCategoryChange}
        />
      </TableCell>
      <TableCell className={muted}>
        <span className="flex items-center gap-2">
          {line.description}
          {!line.in_scope && <OutOfScopeTag />}
        </span>
      </TableCell>
      <TableCell
        align="right"
        className={muted}>
        {line.quantity ?? '—'}
      </TableCell>
      <TableCell
        align="right"
        className={muted}>
        {line.unit_cost == null ? 'Usage' : dollars(line.unit_cost)}
      </TableCell>
      <TableCell
        align="right"
        className={`font-semibold ${muted}`}>
        {dollars(line.monthly_cost)}
      </TableCell>
    </TableRow>
  );
};
